module.exports = __webpack_public_path__ + "static/media/eft.f08dd80f.png";